import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
export const PopoverPortal = ({ children, ...otherProps }) => (_jsx(PopoverPrimitive.Portal, { ...otherProps, children: children }));
